import React, { useEffect, useState } from "react";
import "./index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faShoppingCart,
  faTimes,
  faBolt,
  faBookOpen,
  faTags,
  faArrowLeft,
  faBicycle,
} from "@fortawesome/free-solid-svg-icons";
import Nav from "./components/Nav.jsx";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import { bikes } from "./data";
import Bike from "./Pages/Bike";
import BikeInfo from "./Pages/BikeInfo";
import Cart from "./Pages/Cart";
import Contact from "./Pages/Contact.jsx";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { Analytics } from "@vercel/analytics/react";
import Login from "./components/modals/Login.jsx";
// import library.add(
//   faBars,
//   faShoppingCart,
//   faTimes,
//   faBolt,
//   faBookOpen,
//   faTags,
//   faArrowLeft,
//   faBicycle
// );

function App() {

  const [cart, setCart] = useState([]);

  function addToCart(bike) {
    const dupeItem = cart.find((item) => item.id === bike.id);
    setCart((oldCart) =>
      dupeItem
        ? [
          ...oldCart.map((item) => {
            return item.id === dupeItem.id
              ? {
                ...item,
                quantity: item.quantity + 1,
              }
              : item;
          }),
        ]
        : [...oldCart, { ...bike, quantity: 1 }]
    );
  }

  function updateCart(item, newQuantity) {
    setCart((oldCart) =>
      oldCart.map((oldItem) => {
        if (oldItem.id === item.id) {
          return {
            ...oldItem,
            quantity: newQuantity,
          };
        } else {
          return oldItem;
        }
      })
    );
  }

  // change quantity
  function changeQuantity(bike, quantity) {
    setCart(cart.map(
      (bike) => +bike.id === +quantity ?
        {
          ...bike,
          quantity: +quantity
        } :
        bike
    ))
  }

  function removeItem(item) {
    setCart((oldCart) => oldCart.filter((cartItem) => cartItem.id !== item.id));
  }

  function numberOfItems() {
    let counter = 0;
    cart.forEach((item) => {
      counter += +item.quantity;
    });
    return counter;
  }

  function calcPrices() {
    let total = 0;
    cart.forEach((item) => {
      total += (item.salePrice || item.originalPrice) * item.quantity;
    });
    return {
      subtotal: total * 0.9,
      tax: total * 0.1,
      total,
    };
  }

  useEffect(() => {
    // console.log(cart);
  }, [cart])

  return (
    <Router>
      <div className="App">
        <Analytics />
        <Nav numberOfItems={numberOfItems()} />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/Bikes" exact element={<Bike bikes={bikes} />} />
          <Route
            path="/Bikes/:id"
            element={<BikeInfo bikes={bikes} cart={cart} addToCart={addToCart} />}
          />
          <Route
            path="/login"
            element={<Login />}
          />
          {/* <Route
            path="/contact"
            element={<Contact />}
          /> */}
          <Route
            path="/Cart"
            element={
              <Cart
                cart={cart}
                updateCart={updateCart}
                changeQuantity={changeQuantity}
                removeItem={removeItem}
                totals={calcPrices}
              />
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;